import React, { useContext, useEffect, useRef, useState } from 'react';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { ApiContext } from '@api/api';
import { LovDTO, CompanyModuleEnum } from '@api/ringil-api.v2';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  companyId: string;
  inheriterId: string;
  onChange: (inheriterId: string) => void;
  module: CompanyModuleEnum;
  locationId?: string;
  style?: any;
  placeholder?: string;
  showClear?: boolean;
  readonly?: boolean;
  dataTestId?: string;
}

/**
 * Entity owner is the paying customer of the functionality or the inherited party that creates the entity for the paying customer
 * @param inheriterId - company that inherites the permission
 * @param onChange
 * @param style
 * @constructor
 */
const InputInheriterCompanyRES: React.FC<ComponentProps> = ({
                                                              inheriterId,
                                                              module,
                                                              companyId,
                                                              locationId,
                                                              onChange,
                                                              style,
                                                              placeholder,
                                                              showClear = false,
                                                              readonly = false,
                                                              dataTestId,
                                                            }) => {
  const { loggedUser } = useContext(AuthenticatedUserContext);
  const [options, setOptions] = useState<LovDTO[]>([]);
  const { lovAllCompaniesByInheritModule, getCarriersInputReservation } = useContext(ApiContext);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [dataTestId, options]);

  useEffect(() => {
    if (loggedUser) {
      if (companyId) {
        if (amIOwner) {
          lovAllCompaniesByInheritModule(module, d => {
            setOptions(d);
          });
        } else {
          getCarriersInputReservation(locationId, d => {
            setOptions(d);
          });
          onChange(loggedUser.companyId);
        }
      } else {
        setOptions([]);
      }
    }
  }, [companyId, loggedUser]);

  const amIOwner = companyId === loggedUser?.companyId;
  return (
    <>
      {loggedUser && (
        <div ref={wrapperRef} style={{ width: '100%' }}>
          <Dropdown
            style={{ width: '100%', ...style }}
            value={inheriterId}
            options={options}
            optionLabel={'name'}
            optionValue={'id'}
            placeholder={placeholder}
            disabled={readonly}
            showClear={showClear}
            filter
            onChange={e => {
              onChange(e.value);
            }}
            itemTemplate={(option: LovDTO) => (
              <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || '')}` : undefined}>{option?.name}</span>
            )}
          />
        </div>
      )}
    </>
  );
};

export default InputInheriterCompanyRES;
